import { mapFirstImage } from '../DataTypes/imageMapper';

export const mapOpenGraph = ({ content }): Content.OpenGraph => ({
	documentType: content?.contentType,
	content: {
		properties: {
			title: content.properties.title ?? null,
			description: content.properties.description ?? null,
			image: mapFirstImage(content.properties.image),
			imageText: content.properties.imageText ?? null,
		},
	},
});
